"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const main_component_1 = require("./main.component");
const details_component_1 = require("./child_routes/details.component");
const project_picker_component_1 = require("./project_picker.component");
const upload_component_1 = require("./child_routes/upload.component");
const Routes = [
    {
        path: '', component: project_picker_component_1.ProjectPickerComponent
    },
    {
        path: ':projId/:sceneId/:tabId', component: main_component_1.MainComponent,
        children: [
            { path: 'upload', component: upload_component_1.UploadComponent },
            { path: ':objType/:layerId', component: details_component_1.DetailsComponent },
            { path: ':objType/:layerId/jump/:jump', component: details_component_1.DetailsComponent }
            //{path: '**', component: TBAComponent}
        ]
    }
];
class ProjectMapModule {
}
exports.ProjectMapModule = ProjectMapModule;
